import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/static/css/main.scss'

import Util from '@/common/utils/Util'
import ConstCode from '@/common/constants/ConstCode'
import {
  modalAlertNames,
  modalNames,
  globalComponentNames
} from '@/components/common/globalComponent'
import dayjs from 'dayjs'
import lodash from 'lodash'

import CommonSvc from '@/common/service/CommonSvc'
import SignSvc from '@/common/service/SignSvc'
import ManageSvc from '@/common/service/ManageSvc'
import InfoSvc from '@/common/service/InfoSvc'
import ServiceSvc from '@/common/service/ServiceSvc'
import PaySvc from '@/common/service/PaySvc'

const app = createApp(App)

app.config.globalProperties.$Util = Util
app.config.globalProperties.$ConstCode = ConstCode
app.config.globalProperties.$dayjs = dayjs
app.config.globalProperties.$_ = lodash

app.config.globalProperties.$CommonSvc = CommonSvc
app.config.globalProperties.$SignSvc = SignSvc
app.config.globalProperties.$ManageSvc = ManageSvc
app.config.globalProperties.$InfoSvc = InfoSvc
app.config.globalProperties.$ServiceSvc = ServiceSvc
app.config.globalProperties.$PaySvc = PaySvc

// 전역 컴포넌트 등록
for (let key in modalAlertNames) {
  app.component(modalAlertNames[key])
}
for (let key in modalNames) {
  app.component(modalNames[key])
}
for (let key in globalComponentNames) {
  app.component(globalComponentNames[key].name, globalComponentNames[key])
}

app.config.globalProperties.$modalAlertNames = modalAlertNames
app.config.globalProperties.$modalNames = modalNames

app.use(store).use(router).mount('#app')
